module.exports = __webpack_public_path__ + "static/media/full-team.bc5eb802.jpg";